// Can.jsx
import { useAuth } from '../Providers/AuthContext';

export const Can = ({
                        children,
                        I: singleAction,      // Single action (backward compatible)
                        a: singleSubject,     // Single subject (backward compatible)
                        any: permissions = [],// Array of {action, subject} objects
                        fallback = null
                    }) => {
    const { ability } = useAuth();

    // Check multiple permissions (OR logic)
    if (permissions.length > 0) {
        const hasAnyPermission = permissions.some(({ action, subject }) =>
            ability?.can(subject, action)
        );

        return hasAnyPermission ? children : fallback;
    }

    // Check single permission (original functionality)
    if (singleAction && singleSubject) {
        return ability?.can(singleSubject, singleAction)
            ? children
            : fallback;
    }

    return fallback;
};
